"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_WEBGATE_URL = 'https://wgint.spotify.net';
//# sourceMappingURL=constants.js.map